import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_OLO_DEACTIVATION_VALIDATION} from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDolDeactivationValidationState extends EntityState<IID_OLO_DEACTIVATION_VALIDATION, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OLO_DEACTIVATION_VALIDATION , realtimeEntity: 'IID_OLO_DeactivationValidation'})
@InterfaceDataStore(InterfaceName.OLO_DEACTIVATION_VALIDATION)
export class IIDolDeactivationValidationStore extends EntityStore<IIDolDeactivationValidationState> {
  constructor() {
    super([]);
  }
}
